export interface Environment {
    tabletopCoreApiUrl: string;
    priceUrl?: string;
    stage?: "dev" | "prd" | "stg";
    mock?: boolean;
};

export const defaultConfig: Environment ={
    tabletopCoreApiUrl: "http://nohost",
    priceUrl: "http://nohost",
    stage: "dev",
    mock: false,
};

class Config {
    config: Environment = defaultConfig;
}

export const env = new Config();

export const configUrl = "config/config.json";
